import { HelpLink } from 'elements/link/HelpLink'
import { ComponentVersionsInherit, ComponentVersions_3_0, Typography } from 'opensolar-ui'
import useTranslateParse from '../../util/useTranslateParse'

const PricingSchemeTitle = ({ record, translate, style }) => {
  return (
    <ComponentVersionsInherit versions={ComponentVersions_3_0}>
      <Typography style={style}>
        {translate('Pricing Scheme')}: {record ? `"${record.title}"` : ''}
      </Typography>
    </ComponentVersionsInherit>
  )
}

const Subtitle = () => {
  const translateParse = useTranslateParse()
  return (
    <Typography variant="body2">
      {translateParse(
        'Set your price schemes method here. The most common methods are price-per-watt (varying based on size), and \'cost-plus\' pricing. If you have more than one pricing method, you can set one as a default and select an alternative pricing method for a given project in the Design page. Note: If you select "Cost-plus" pricing, you can update your COGS <a>here<a>.',
        { a: (label) => <a href={'/costings'}>{label}</a> }
      )}{' '}
      <HelpLink href="https://support.opensolar.com/hc/en-us/articles/12519221319311-How-to-set-up-Pricing-Schemes" />
    </Typography>
  )
}

export default {
  list: { lazy: () => import('./PricingSchemes'), component: 'PricingSchemeList' },
  edit: { lazy: () => import('./PricingSchemes'), component: 'PricingSchemeEdit' },
  create: { lazy: () => import('./PricingSchemes'), component: 'PricingSchemeCreate' },
  options: {
    create: {
      title: 'Create Pricing Scheme',
      subtitle: null,
      breadCrumb: 'Create Pricing Scheme',
    },
    list: {
      title: 'My Pricing Schemes List',
      subtitle: <Subtitle />,
      breadCrumb: 'Pricing Schemes',
    },
    edit: {
      title: <PricingSchemeTitle />,
      subtitle: null,
      breadCrumb: 'Edit Pricing Scheme',
    },
  },
}
